<template>
  <OverviewTeasersFi
    :fields="fields"
    :api-url="apiUrl"
  />
</template>

<script>
import OverviewTeasersFi from 'components/overview-teasers-fi/OverviewTeasersFi';

export default {
  name: 'TeaserOverviewFi',
  components: {
    OverviewTeasersFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    apiUrl() {
      if (IS_SHOWROOM) {
        return '/__mocks__/sitecoreApi/api/teaser/get/mockedTeaserData.json';
      }

      return '/api/teaser/get';
    },
  },
};
</script>

<style scoped lang="scss">
@import './teaser-overview-fi';
</style>
